module.exports = __webpack_public_path__ + "static/media/our_values.c24675a8.jpg";